import SiteSettings from "src/siteSetting";
import CoreAPIKeyFacade from "./coreApiFacade";


/**
 * The TokenGenerator class defines the `getInstance` method that lets clients access
 * the unique singleton instance.
 */
class TokenGenerator {
    private static instance: TokenGenerator;
    facade: string;
    facades: any;
    inMemoryExpiresIn: number = 300;
    environment: string = 'app';

    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() {
        this.facade = SiteSettings.graphqlAuthenticationFacade()
        this.facades = {
            coreapi: new CoreAPIKeyFacade()
        }

    }

    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    public static getInstance(): TokenGenerator {
        if (!TokenGenerator.instance) {
            TokenGenerator.instance = new TokenGenerator();
        }

        return TokenGenerator.instance;
    }

    public getToken() {
        const token = this.facades.coreapi.getToken()
        return token
    }

}

export {
    TokenGenerator
}
